class CollectionRepository {
	constructor() {
		this.collection = [];
	}
}

let collectionRepository = new CollectionRepository();

export default collectionRepository;


// WEBPACK FOOTER //
// ./rapid/collectionRepository.js